export enum GrowthMedium {
  CASO = "caso",
  MALT = "malt",
  DG18 = "dg18",
}
